import React from 'react';
import { Typography } from '@mui/material';
import { QualificationRender } from '../../lib/CommonComponents';
import { useRecordContext } from 'react-admin';

export const QualificationList = () => {
    const record = useRecordContext();
    let qualId = "";
    let canRender = false;
   
        if(record?.exitPoints?.length > 0){
            canRender = true;
            var finalExitPoint = record.exitPoints.find(obj => {
                return obj.intermediateOrFinal == "Final"
            });
            
            if(finalExitPoint == undefined){
                canRender = false;
            }
            else{
                qualId = finalExitPoint.qualificationId;
            }
        }

    return canRender? (
        <QualificationRender qualificationId={qualId} />
    ) : (<></>);
};